import { createContext } from "react";
import IAppSessionState from "./IAppSessionState";

export interface IAppState {
  sessionState: IAppSessionState;
  loadingSessionState: boolean;
  setSessionState: (sessionState: IAppSessionState) => void;
  clearSession: () => void;
}

const AppStateContext = createContext<IAppState>(null as any);

export default AppStateContext;
